// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/listaFiltros.ts
//  Filtros das listas do Operacional (DAV, orçamentos, OS, condicional,
//  entregas, cargas, PCP, requisições, garantias). Tudo vai ao SERVIDOR:
//  busca, status, período (dtInicio/dtFim, dia local) e ordenação.
// ════════════════════════════════════════════════════════════════════════════

import type { PaginadoResponse } from '../types';

export interface ListaFiltros {
  busca?: string;
  /** Valor do select de status; 'todos' (ou vazio) não filtra. */
  status?: string;
  dtInicio?: string;
  dtFim?: string;
  ordenarPor?: string;
  decrescente?: boolean;
}

/** Resposta paginada com os KPIs (`resumo`) do conjunto busca+período inteiro, não só da página. */
export interface PaginadoComResumo<T, R> extends PaginadoResponse<T> {
  resumo?: R;
}

/** Query params da lista: só manda o que tem valor (sem parâmetro o servidor não limita). */
export const paramsDaLista = (pagina: number, tamanhoPagina: number, f: ListaFiltros = {}) => ({
  pagina,
  tamanhoPagina,
  busca:       f.busca?.trim() || undefined,
  status:      f.status && f.status !== 'todos' ? f.status : undefined,
  dtInicio:    f.dtInicio || undefined,
  dtFim:       f.dtFim || undefined,
  ordenarPor:  f.ordenarPor || undefined,
  decrescente: f.decrescente,
});

// ── KPIs de cada lista (campo `resumo`) ───────────────────────────────────

export interface DavListaResumo { abertos: number; valorAbertos: number; baixados: number; entregues: number }
export interface OrcamentoListaResumo { abertos: number; valorAbertos: number; aprovados: number; expirados: number }
export interface OsListaResumo { abertas: number; valorAbertas: number; emAndamento: number; concluidas: number }
export interface CondicionalListaResumo { abertas: number; valorAberto: number; vendidas: number; devolvidas: number }
export interface EntregaListaResumo { pendentes: number; emRota: number; entregues: number; valorTotalCarga: number }
export interface CargaListaResumo { montagem: number; emRota: number; retornadas: number; finalizadas: number }
export interface PcpListaResumo { abertas: number; emAndamento: number; finalizadas: number; custoPrevisto: number }
export interface RequisicaoListaResumo { pendentes: number; aprovadas: number; realizadas: number }
export interface GarantiaListaResumo { vigentes: number; acionadas: number; expiradas: number }
